// extracted by mini-css-extract-plugin
export default {"desktop-wrapper":"desktop-wrapper--OELbb"};